export { ProposalsCard } from './ProposalsCard';
